import { PERSONAL_DETAIL, PERSONAL_DETAIL_SUCCESS, PERSONAL_DETAIL_ERROR, PERSONAL_DETAIL_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const PersonalDetail = (state = initialState, action) => {
  switch (action.type) {
    case PERSONAL_DETAIL:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case PERSONAL_DETAIL_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case PERSONAL_DETAIL_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case PERSONAL_DETAIL_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default PersonalDetail;
